export const RECONDUCTION_STATUS_OPTIONS = [
    { text: "Reconduit", value: "reconduit", filterValue: "", color: '#23A638', description: 'Contrat reconduit sur la période courante' },
    { text: "Reconductible", value: "reconductible", filterValue: "", color: '#23A638', description: 'Contrat reconduit sur la prochaine période' },
    { text: "Arrêt au terme", value: "arret", filterValue: "", color: '#EE7202', description: 'Contrat arrêté au terme de la période courante' }
]